import { format } from "date-fns";
import { parseDate } from "./parseDate";
/** conversion for legacy formats */ var dateFormatToDateFnsFormat = {
    DATE_FULL: 'MMMM d, yyyy',
    DATE_MED: 'MMM d, yyyy',
    a: 'yyyy-MM-dd'
};
export function formatDate(value) {
    var dateFormat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'M/d/yyyy';
    try {
        var date = parseDate(value);
        if (!date || isNaN(date.valueOf()) || typeof value === 'string' && !value.includes(date.getFullYear().toString())) {
            return value;
        }
        return format(date, dateFormatToDateFnsFormat[dateFormat] || dateFormat);
    } catch (e) {
        return value;
    }
}

//# sourceMappingURL=formatDate.js.map